<template>
  <div>
    <NoPage/>
  </div>
</template>

<script>
import NoPage from '@/components/NoPage.vue'
export default {
  data() {
    return {}
  },
  components: {
    NoPage
  }
}
</script>
